import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=5308d835&scoped=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=ts"
export * from "./CustomerDashboard.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDashboard.vue?vue&type=style&index=0&id=5308d835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5308d835",
  null
  
)

export default component.exports